import { render, staticRenderFns } from "./AdviserChannelSelector.vue?vue&type=template&id=85153eba&scoped=true"
import script from "./AdviserChannelSelector.vue?vue&type=script&lang=js"
export * from "./AdviserChannelSelector.vue?vue&type=script&lang=js"
import style0 from "./AdviserChannelSelector.vue?vue&type=style&index=0&id=85153eba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85153eba",
  null
  
)

export default component.exports